import { IRootState } from 'store/rootReducer';
import { initialState, migrosLoginStatuses } from './login';

export const getLoginRedirectRoutePath = (state: IRootState) => {
	return state.login.redirectRoutePath;
};

export const getMigrosLoginStatus = (state: IRootState) => {
	return state.login.migrosLoginStatus;
};

/*
 * Returns true if Migros is authenticated
 */
export const getIsMigrosAuthenticated = (state: IRootState) => {
	return (
		getMigrosLoginStatus(state) === migrosLoginStatuses.AUTHENTICATED ||
		getMigrosLoginStatus(state) === migrosLoginStatuses.LOGGEDIN
	);
};

/*
 * Returns true if Spring and Migros login was attempted or we can assume we are logged in
 */
export const getHasAuthenticationLoaded = (state: IRootState) => {
	return state.login.migrosLoginStatus !== initialState.migrosLoginStatus;
};

/*
 * Returns true if Migros is authenticated
 */
export const getIsAuthenticated = (state: IRootState) => {
	return getIsMigrosAuthenticated(state);
};
